import {
    OpType,
    SubscriptionMessage
} from '@aws-amplify/datastore';

import { DataStore } from 'aws-amplify';
import { POLICY_TEMPLATE_LINKS_QUERY_KEY } from '../permission/cedar/hooks/usePermissionCheck';
import { PolicyTemplateLink } from '../../models';
import { useQueryClient } from 'react-query';

let subscription: ZenObservable.Subscription | undefined;

export const usePermissionsSubscription = () => {
    const queryClient = useQueryClient();

    const subscribe = async (propertyId: string) => {
        subscription = DataStore.observe(PolicyTemplateLink, (link) =>
            link.resourceId("eq", propertyId)
        ).subscribe({
            next: (message: SubscriptionMessage<PolicyTemplateLink>) => {
                handlePolicyTemplateLinkUpdate(message);
            },
            error: (error) => console.warn(error)
        });
    };

    const handlePolicyTemplateLinkUpdate = (message: SubscriptionMessage<PolicyTemplateLink>) => {
        const policyTemplateLink = message.element;

        if (message.opType === OpType.DELETE) {
            queryClient.setQueryData(POLICY_TEMPLATE_LINKS_QUERY_KEY, (old: PolicyTemplateLink[] | undefined) => {
                return old?.filter(link => link.id !== policyTemplateLink.id) ?? [];
            });
            return;
        }

        queryClient.setQueryData(POLICY_TEMPLATE_LINKS_QUERY_KEY, (old: PolicyTemplateLink[] | undefined) => {
            const isExisted = old?.some(link => link.id === policyTemplateLink.id);
            if (isExisted) {
                return old?.map(link => link.id === policyTemplateLink.id ? policyTemplateLink : link) as PolicyTemplateLink[];
            } else {
                return [...(old ?? []), policyTemplateLink] as PolicyTemplateLink[];
            }
        });
    };

    const unsubscribe = () => {
        subscription?.unsubscribe();
    };

    return { subscribe, unsubscribe };
};